import api from "./init";
import { headers } from "./apiHelper";

export const getTickets = (id, resolveHandler, offset = 0, limit = 100) => {
  api
    .get("/tickets", {
      headers,
      params: {
        offset: `${offset}`,
        limit: `${limit}`,
        "filter[categoryId]": JSON.parse(
          localStorage.getItem("whell_user_info")
        )?.categoryId,
      },
    })
    .then((res) => {
      resolveHandler(res.data);
    });
};

export const getTicket = (id, resolveHandler) => {
  api
    .post(
      "/exams",
      {
        type: "TICKET",
        entityId: id,
      },
      {
        headers,
      }
    )
    .then((res) => {
      resolveHandler(res.data);
    });
};

export const submitTicket = (examID, examAnswers, examTime, resolveHandler) => {
  api
    .post(
      `/exams/${examID}`,
      {
        answers: examAnswers,
        time: examTime,
      },
      {
        headers,
      }
    )
    .then((res) => {
      resolveHandler(res.data);
    });
};
